<h1 mat-dialog-title>Address Restoration</h1>
<div mat-dialog-content>
    You are about to restore this entry, Please confirm:
    <div>{{data.name}}, {{data.corp_id}}, {{data.streetAddress1}} </div>
    <div>{{data.city}}, {{data.state}}, {{data.postalCode}}</div>
</div>
<div mat-dialog-actions>
  <button type="button" mat-button mat-dialog-close (click)="close(false)">Cancel</button>
  <button type="button" mat-raised-button color="primary" mat-dialog-close (click)="close(true)">Confirm Restore</button>

</div>
